import { RecipeFeatures } from './RecipeFeatures';

export type { TypeRecipeFeaturesProps } from './types';
export default RecipeFeatures;
